import { DivIcon, Util, Marker } from "leaflet";
import { MapHtml } from "../map-html";
import { Connection, MapSettings } from "../models";
import { Colors } from "../markerColors";

export class ConnectionMarkerBuilder {
  static buildMarker(conn: Connection, settings: MapSettings, selected: boolean): Marker {
    const colorIndex = conn.lineType == 'A' ? 2 : (conn.sourceType == 'K' ? 0 : 1)
    const trColor = Colors.colors[colorIndex];
    const anchor: L.PointExpression = [12, 14];
    let divIcon: DivIcon;

    if (settings.detailed) {
      const html = MapHtml.getConnMarker(conn, trColor, settings.extraDetailed);
      divIcon = new DivIcon({
        className: 'trRoot',
        html: html,
        iconSize: undefined,
        iconAnchor: settings.extraDetailed ? [42, 32] : anchor,
        popupAnchor: [0, settings.extraDetailed ? -32 : -12]
      });
    }
    else {
      let iconSettings = {
        mapIconUrl: MapHtml.getConnMarkerIcon(conn),
        mapIconColor: trColor
      };

      divIcon = new DivIcon({
        className: `"trIcon${selected ? ' selected' : ''}"`,
        html: Util.template(iconSettings.mapIconUrl, iconSettings),
        iconAnchor: anchor,
        iconSize: [25, 27],
        popupAnchor: [0, -12]
      });
    }

    const options = { riseOnHover: true, icon: divIcon, cid: conn.id };
    const marker = new Marker([conn.lat, conn.lon], options);

    marker.bindPopup(MapHtml.getConnPopup(conn), { closeButton: false, autoClose: !selected });

    return marker;
  }
}
